import {useCallback} from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import {AutocompleteCombo} from '../../common/AutocompleteCombo';
import {useCatalog} from '../../../store/catalog';
import {useSelect} from "@wordpress/data";
import {CATALOG_STORE_KEY} from "../../../constants";

export const SearchFilter = ({config, value, onChange}) => {
    const {source} = useCatalog();
    const snap = useSelect(select => select(CATALOG_STORE_KEY)?.getRequestSnapshot(), []);

    const fetchPage = useCallback(async (query, page) => {
        const attribute = config.attribute || config.field;
        const size = config.size || 10;

        const appliedFilters = (snap?.filters || []).filter(f => f.field !== attribute);

        if (snap?.selectedCategory) {
            appliedFilters.push({
                field: 'categoryId',
                operator: 'EQUALS',
                value: snap.selectedCategory.id,
            });
        }

        const path = `/api/products/attribute-values/${encodeURIComponent(attribute)}?page=${page}&size=${size}` + (query ? `&q=${encodeURIComponent(query)}` : '');

        const res = await apiFetch({
            path,
            method: 'POST',
            data: appliedFilters,
        });

        const items = Array.isArray(res?.items) ? res.items.map(it => {
            if (typeof it === 'string') return {value: it, label: it};
            const val = it.value || it[attribute] || it.id || '';
            const lab = it.label || it.name || it[attribute] || val || '';
            return {
                value: val,
                label: lab,
                count: it.count,
            };
        }) : [];

        return {
            items,
            page: res?.page ?? page,
            size: res?.size ?? size,
            totalPages: res?.totalPages ?? undefined,
        };
    }, [config.attribute, config.field, config.provider, config.size, source, snap]);

    const multiple = !!config.multiple;

    const handleChange = (next) => {
        if (multiple) {

            const vals = Array.isArray(next) ? next.map(v => typeof v === 'string' ? v : v?.value).filter(Boolean) : [];
            onChange(vals);
        } else {
            const val = typeof next === 'string' ? next : next?.value ?? '';
            onChange(val || '');
        }
    };

    return (
        <div className="mb-2">
            <AutocompleteCombo
                placeholder={config.placeholder || `Search ${config.label}`}
                multiple={multiple}
                value={value || (multiple ? [] : '')}
                onChange={handleChange}
                fetchPage={fetchPage}
                debounceMs={config.debounceMs || 300}
                getOptionLabel={opt => typeof opt === 'string' ? opt : (opt?.label ?? opt?.value ?? '')}
                getOptionValue={opt => typeof opt === 'string' ? opt : (opt?.value ?? '')}
            />
        </div>
    );
};
